// extracted by mini-css-extract-plugin
export default {"MuiTableCell-head":"TableCells_MuiTableCell-head__IXHMx","MuiTableCell-body":"TableCells_MuiTableCell-body__bOHB3"};